// Helper function that sorts the objects of an array alphabetically by their name property

export function sortObjectsByName(arr) {

    arr.sort(function(a, b) {
      var catA = a.name.toLowerCase();
      var catB = b.name.toLowerCase();
      return (catA < catB) ? -1 : (catA > catB) ? 1 : 0;
    })

    return arr;

}